<div class="container">
    <div class="top-section">
        <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
    </div>
    <form class="bottom-section" [formGroup]="ratingAndReview" *ngIf="orderItem && !isLoading">
        <div class="heading-section">
            <img class="product-image" [src]="orderItem.product?.images?.imagesUrl?.[0]" />
            <p class="feedback-header">{{ "userReviewPage.questioning" | translate }}</p>
        </div>
        <div class="star-container">
            <mat-icon
                class="star-icon"
                *ngFor="let star of stars; let i = index"
                [class.selected]="i < ratingAndReview.get('rating')?.value"
                (click)="selectRating(i + 1)"
            >
                {{ i < ratingAndReview.get("rating")?.value ? "star" : "star_border" }}
            </mat-icon>
        </div>

        <div class="input-container">
            <label for="review" class="review-label">{{ "userReviewPage.label.writeReview" | translate }}</label>
            <textarea
                class="review-input"
                id="review"
                rows="10"
                formControlName="review"
                placeholder="{{ 'userReviewPage.placeholder.review' | translate }}"
            ></textarea>
        </div>

        <div class="input-container">
            <label class="photo-label">{{ "userReviewPage.label.sharePhoto" | translate }}</label>
            <input
                class="image-input"
                type="file"
                id="images"
                multiple
                accept="image/jpeg, image/png, image/webp, image/gif"
                (change)="onFileSelected($event)"
                [disabled]="images.imagesUrl.length >= 5"
            />
            <div *ngIf="isLoading" class="spinner-overlay">
                <mat-spinner diameter="45"></mat-spinner>
            </div>
            <div class="camera-icon-container">
                <label for="images" class="camera-icon-label">
                    <mat-icon
                        [matTooltip]="images.imagesUrl.length >= 5 ? 'Maximum 5 images allowed' : ''"
                        class="camera-icon"
                        >photo_camera</mat-icon
                    >
                </label>
            </div>

            <div class="preview" *ngIf="images.imagesUrl.length > 0">
                <div *ngFor="let img of images.imagesUrl; let i = index" class="preview-image">
                    <img class="upload-image" [src]="img" [alt]="'Image ' + (i + 1)" />
                    <mat-icon class="remove-icon" (click)="removeImage(i)">delete</mat-icon>
                </div>
            </div>
        </div>

        <div class="bottom-container">
            <button class="save-btn" (click)="submitReview()" [disabled]="ratingAndReview.invalid" mat-flat-button>
                {{ "userReviewPage.button.submit" | translate }}
            </button>
        </div>
    </form>

    <div class="no-order-container" *ngIf="!orderItem && !isLoading">
        <app-no-order-item></app-no-order-item>
    </div>
</div>
